import { InitState, InitUserRole, isValidDate, useUserInitAccess, UUID } from "@gx1/gx-npm-lib";
import {
  SnackbarBanner,
  MiniButton,
  RestoreArchivedFolderIcon,
  RestoreDeletedTrashcanIcon,
} from "@gx1/gx-npm-ui";
import { TypographyComponent } from "@gx1/gx-ui-common";
import { Fragment, useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { MainNavAppV2Context } from "../../../app-v2.context";
import styles from "./init-state-banner.styles.module.scss";

const formatDate = (date: string) => {
  let finalDate = "";
  if (isValidDate(date)) {
    const day = "numeric";
    const month = "long";
    const timeZone = "UTC";
    const year = "numeric";
    const options = { day, month, timeZone, year } as const;
    finalDate = new Date(date).toLocaleString("en-us", options);
  }
  return finalDate;
};

const InitStateBannerComponent = () => {
  const { t } = useTranslation();
  const [isFailedUpdate, setIsFailedUpdate] = useState(false);
  const [isSuccessfulUpdate, setIsSuccessfulUpdate] = useState(false);
  const { initState, stateUpdateDate, setInitState } = useContext(MainNavAppV2Context);
  const { initiativeId = "" } = useParams<{ initiativeId: UUID }>();
  const { role } = useUserInitAccess(initiativeId);

  const displayDate = formatDate(stateUpdateDate);

  const handleClickRestoreEval = async () => {
    try {
      const url = `${window.gxApiConnection}/api/v2/initiatives/${initiativeId}/action/active`;
      const response = await window.fetch(url, {
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        method: "POST",
      });
      if (!response.ok) {
        throw new Error();
      }
      setIsSuccessfulUpdate(true);
      setInitState(InitState.ACTIVE);
    } catch {
      setIsFailedUpdate(true);
    }
  };

  return (
    <Fragment>
      {[InitState.ARCHIVED, InitState.DELETED].includes(initState as InitState) && (
        <div className={styles.root}>
          <TypographyComponent element={"p"} styling={"metadata-sm"} rootClassName={styles.text}>
            {initState === InitState.ARCHIVED && t("Archived")}
            {initState === InitState.DELETED && t("Deleted")}
            {displayDate && ` on ${displayDate}`}
          </TypographyComponent>
          {role === InitUserRole.OWNER &&
            <MiniButton onClick={handleClickRestoreEval}>
              {initState === InitState.ARCHIVED && <div className={styles.restoreBtnWrapper}><RestoreArchivedFolderIcon /> {t("Unarchive")}</div>}
              {initState === InitState.DELETED && <div className={styles.restoreBtnWrapper}><RestoreDeletedTrashcanIcon /> {t("Restore From Trash")}</div>}
            </MiniButton>
          }
        </div>
      )}
      <SnackbarBanner
        autoHideDuration={3000}
        isOpen={isSuccessfulUpdate}
        message={t("Evaluation has been restored.")}
        setIsOpen={() => setIsSuccessfulUpdate(false)}
        type="SUCCESS"
      />
      <SnackbarBanner
        autoHideDuration={3000}
        isDefaultErrorMessage={true}
        isOpen={isFailedUpdate}
        setIsOpen={() => setIsFailedUpdate(false)}
        type="ERROR"
      />
    </Fragment>
  );
};

export default InitStateBannerComponent;
